import { HttpClient } from "@angular/common/http";
import { AfterViewInit, Component, ElementRef, OnInit, ViewChild } from "@angular/core";
import * as moment from "moment";
import { OnBoardApiService } from "src/app/services/onboard.api.service";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { ToastrService } from "ngx-toastr";
import { NgxUiLoaderService } from "ngx-ui-loader";
import { UserApiService } from "src/app/services/user.api.service";
import { ActivatedRoute, Router } from "@angular/router";
import Docxtemplater from "docxtemplater";
import PizZip from "pizzip";
import { environment } from "src/environments/environment";
@Component({
  selector: "app-form-page",
  templateUrl: "./form-page.component.html",
  styleUrls: ["./form-page.component.scss"],
})
export class FormPageComponent implements OnInit, AfterViewInit {
  @ViewChild("pdfViewer", { static: true }) pdfViewer: ElementRef;

  agreement_date: any;
  company_name: string = "";
  designation: string = "";
  phone: string = "";
  email: string = "";
  date: any;
  director_name: string = "";
  father_name: string = "";
  address: string = "";
  place: string = "";
  charted_name: string = "";
  charted_phone: string = "";
  charted_email: string = "";
  firstName: string = "";
  lastName: string = "";
  user_id: string = "";
  aggrement: boolean = false;
  previewDocumentUrl: string = "assets/termsCondition.pdf";
  attachment: any;
  constructor(
    private http: HttpClient,
    private onboardService: OnBoardApiService,
    private toastr: ToastrService,
    private userApi: UserApiService,
    private loadr: NgxUiLoaderService,
    private modalService: NgbModal,
    private route: ActivatedRoute,
    private router: Router
  ) {}
  ngAfterViewInit(): void {}

  ngOnInit(): void {
    this.route.paramMap.subscribe((params) => {
      this.user_id = params.get("id");
      this.initialSetup();
    });
  }
  initialSetup() {
    let body = { user_id: this.user_id };
    this.loadr.start();
    this.userApi
      .getUserById(body)
      .then((response) => {
        this.agreement_date = response?.kyc_form?.agreement_date ? response.kyc_form.agreement_date.split("T")[0] : new Date().toISOString().split("T")[0];
        this.company_name = response?.kyc_form?.company_name || "";
        this.designation = response?.kyc_form?.designation || "";
        this.phone = response?.kyc_form?.phone || "";
        this.email = response?.kyc_form?.email || "";
        this.date = response?.kyc_form?.date ? (response?.kyc_form?.date).split("T")[0] : "";
        this.director_name = response?.kyc_form?.director_name || "";
        this.father_name = response?.kyc_form?.father_name || "";
        this.address = response?.kyc_form?.address || "";
        this.place = response?.kyc_form?.place || "";
        this.charted_name = response?.kyc_form?.charted_name || "";
        this.charted_phone = response?.kyc_form?.charted_phone || "";
        this.charted_email = response?.kyc_form?.charted_email || "";
        this.aggrement = response?.kyc_form?.aggrement || false;
        this.loadr.stop();
      })
      .catch((error) => {
        this.toastr.error(error);
        this.loadr.stop();
      });
  }
  onSubmit(form: any) {
    this.generate(form);
    this.modalService.open(this.pdfViewer, { size: "lg", centered: true }).result.then(
      (result) => {
        let body = {
          user_id: this.user_id,
          agreement_date: moment(form?.agreement_date).format("YYYY-MM-DD") + "T00:00:00.000Z",
          company_name: form?.company_name || "",
          designation: form?.designation || "",
          phone: form?.phone || "",
          email: form?.email || "",
          date: moment(form?.date).format("YYYY-MM-DD") + "T00:00:00.000Z",
          director_name: form?.director_name || "",
          father_name: form?.father_name || "",
          address: form?.address || "",
          place: form?.place || "",
          charted_name: form?.charted_name || "",
          charted_phone: form?.charted_phone || "",
          charted_email: form?.charted_email || "",
          aggrement: form?.aggrement || false,
        };

        Object.keys(body).forEach((key) => {
          if (body[key] === undefined) {
            delete body[key];
          }
        });
        this.loadr.start();
        this.onboardService
          .addKycForm(body)
          .then((result) => {
            // this.loadr.stop();
            this.toastr.success("KYC Form Added Successfully");
            //  this.router.navigate(['/thank-you']);
          })
          .finally(() => {
            const formData = new FormData();
            // formData.append('media', this.attachment, 'onboarding.docx');
            formData.append("media", this.attachment);
            formData.append("user_id", this.user_id);
            let body = {
              user_id: this.user_id,
              media: this.attachment,
            };

            return this.onboardService.addMedia(formData);
          })
          .then((resp) => {
            return this.userApi.getUserById({ user_id: this.user_id });
          })
          .then((res) => {
            this.loadr.stopAll();
            let resposne: any = res?.cloud_convert_url?.media_url;
            this.downloadFile(`${environment.baseUrl}/api/v1/${resposne}`, "Onboarding");
          })
          .catch((err) => {
            console.log(err);
            this.loadr.stop();
            this.toastr.error(err);
          });
      },
      (reason) => {}
    );
  }
  generate(item?: any) {
    if (item) {
      // Path or URL to your local Word file
      const localFilePath = "../../../assets/onboarding.docx";

      // Assuming you are using Angular HttpClient to load the local file
      this.http.get(localFilePath, { responseType: "arraybuffer" as "json" }).subscribe((data) => {
        const arrayBuffer: any = data;
        const zip = new PizZip(arrayBuffer);

        const doc = new Docxtemplater(zip, {
          paragraphLoop: true,
          linebreaks: true,
        });

        doc.setData({
          agreement_date: item?.agreement_date ? (item?.agreement_date).split("T")[0] : "",
          company_name: item?.company_name || "",
          designation: item?.designation || "",
          phone: item?.phone || "",
          email: item?.email || "",
          date: moment.utc(item?.date || "").format("DD/MM/YYYY"),
          director_name: item?.director_name || "",
          father_name: item?.father_name || "",
          address: item?.address || "",
          ca_email: item?.charted_email || "",
          ca_phone: item?.charted_phone || "",
          ca_name: item?.charted_name || "",
          first_name: item?.firstName || "",
          last_name: item?.lastName || "",
          place: item?.place || "",
        });

        try {
          doc.render();
        } catch (error) {
          // Handle error
          throw error;
        }

        const out = doc.getZip().generate({
          type: "blob",
          mimeType: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
        });
        this.attachment = out;
        // saveAs(out, "onboarding.docx");
      });
    }
  }
  downloadFile(url: string, fileName: string): void {
    fetch(url)
      .then((response) => response.blob())
      .then((blob) => {
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = fileName;
        link.click();

        // Clean up and revoke the object URL
        window.URL.revokeObjectURL(link.href);
        document.body.removeChild(link);
      })
      .catch((err) => console.error("Error downloading the file:", err));
  }
}
